"use client";

import { ReactNode } from "react";
import { useSpanishExperienceEnabled } from "@/lib/locale/useSpanishExperienceEnabled";

type SpanishExperienceFeatureProps = {
  children: ReactNode;
};

export function SpanishExperienceFeature({
  children,
}: SpanishExperienceFeatureProps) {
  const { isEnabled, isLoading } = useSpanishExperienceEnabled();

  if (isLoading || !isEnabled) {
    return null;
  }

  return children;
}
